// Custom font-family mark extension.
//
// Mirrors ./font_size — piggy-backs on the official TextStyle mark by adding a
// `fontFamily` global attribute so the chosen font lands in the same span as
// other inline styles (text color, size). This makes font a per-selection
// choice like every other text style in the toolbar, instead of one font
// applied to the whole newsletter.

import { Extension } from "@tiptap/core"

export const FontFamily = Extension.create({
  name: "fontFamily",

  addOptions() {
    return {
      types: ["textStyle"],
    }
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            // Don't strip quotes — multi-word stacks (e.g. 'Segoe UI') need
            // them to stay valid CSS. content_json is canonical anyway; this
            // only fires when importing legacy body HTML.
            parseHTML: (element) => element.style.fontFamily || null,
            renderHTML: (attributes) => {
              if (!attributes.fontFamily) return {}
              return { style: `font-family: ${attributes.fontFamily}` }
            },
          },
        },
      },
    ]
  },

  addCommands() {
    return {
      setFontFamily:
        (fontFamily) =>
        ({ chain }) =>
          chain().setMark("textStyle", { fontFamily }).run(),
      unsetFontFamily:
        () =>
        ({ chain }) =>
          chain().setMark("textStyle", { fontFamily: null }).removeEmptyTextStyle().run(),
    }
  },
})
